export function initUmami(websiteId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.defer = true;
    script.src = 'https://cloud.umami.is/script.js';
    script.dataset.websiteId = websiteId;
    script.onload = () => resolve();
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
